import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { formatCurrency } from "../../../utils/mathUtils";

export const useGetColumnsDetalle = (idTipoProfesional) => {
    const columns = useMemo(() => {
        const baseColumns = [
            {
                field: 'tipo',
                headerName: 'Tipo',
                flex: 1
            },
            {
                field: 'cantidad',
                headerName: 'Cantidad',
                renderCell: ({ row }) => (
                    <>{idTipoProfesional === 7 ? row.horasTotales : row.cantidad}</>
                ),
                flex: 1
            },
            {
                field: 'importe',
                headerName: 'Importe',
                flex: 1,
                valueGetter: (value) => formatCurrency(value || 0)
            },
            {
                field: 'tramo',
                headerName: 'Tramo',
                flex: 1,
                valueGetter: (value) => value ? formatCurrency(value) : ''
            },
            {
                field: 'total',
                headerName: 'Total',
                flex: 1,
                valueGetter: (value) => formatCurrency(value || 0)
            },
        ];

        return generateColumnsDefaultConfiguration(baseColumns);
    }, [idTipoProfesional]);

    return columns;
}